import validator from 'validator';

export function isEmail(email: string) {
  return validator.isEmail(email);
}

export function isUrl(url: string) {
  return validator.isURL(url);
}

export function isIP(ip: string, version: 4 | 6) {
  return validator.isIP(ip, version);
}

export function isIPRange(ip: string, version: 4 | 6) {
  return validator.isIPRange(ip, version);
}

export function isPhone(phone: string) {
  return /^[0-9\-]+$/g.test(phone);
}

export function isMobilePhone(phone: string | undefined) {
  if (!phone) {
    return false;
  }
  return validator.isMobilePhone(phone, 'any', { strictMode: true });
}

export function isHexColor(color: string) {
  return validator.isHexColor(color);
}

export function isPassword(password: string) {
  const regexp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~])[A-Za-z\d!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]{8,}$/g;
  return regexp.test(password);
}
